export default "/img/SY.3a6ba6c411920acc1cf0e34214c9f3b3.png";